"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSearchResultsQuery = exports.QUERY_NAME = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const QUERY_NAME = exports.QUERY_NAME = 'query';
const getSearchResultsQuery = ()=>{
    const query = (0, _presentationUtils.getTypedQueryParam)({
        name: QUERY_NAME
    });
    return (query !== null && query !== void 0 ? query : '').trim();
};
exports.getSearchResultsQuery = getSearchResultsQuery;
